import {call, put} from "redux-saga/effects";
import {SegmentationTypes} from "../redux/SegmentationReducer";

const segmentation = function* (api, action) {
    try {
        const { segmentationData } = action;
        const response = yield call(api.segmentation, segmentationData);
        let responseData = {};
        if (response && response.data) {
            responseData = response.data;
        }

        responseData.rand = Math.random();

        yield put({
            type: SegmentationTypes.SEGMENTATION_SUCCESS,
            segmentation: responseData
        });
    }  catch (error) {
        yield put({
            type: SegmentationTypes.SEGMENTATION_FAILURE,
            error: ""
        });
    }
};

const getSegmentationSchoolChoices = function* (api, action) {
    try {
        const {schoolZipCode} = action,
            response = yield call(api.getSegmentationSchoolChoices, schoolZipCode),
            responseData = response.data,
            choices = [];

        if(responseData.hasOwnProperty("suggestions") && responseData.suggestions.length > 0) {
            for(let i = 0; i < responseData.suggestions.length; i++) {
                choices.push({
                    value: responseData.suggestions[i],
                    label: responseData.suggestions[i],
                });
            }
        }

        yield put({
            type: SegmentationTypes.SEGMENTATION_SCHOOLS_SUCCESS,
            segmentationSchools: choices
        });
    }  catch (error) {
        yield put({
            type: SegmentationTypes.SEGMENTATION_SCHOOLS_FAILURE,
            error: "Can't get schools for this zip code!"
        });
    }
};

export {
    segmentation,
    getSegmentationSchoolChoices,
}